import { Divider, Stack, styled } from "@mui/material"
import { EmptySection, GiftCardIcon } from "@pharmupp/p3-front-commons"
import { ShoppingCart, Users } from "react-feather"
import {
  LoyaltyProgramButton,
  type LoyaltyProgramData,
  LoyaltyProgramEvolution,
  hasLoyaltyProgramData,
} from "../../../LoyaltyProgram"
import { NumberKPIDisplay, PriceKPIDisplay } from "../../../common"
import { SyncDate } from "../commons"
import {
  AverageBasketCardWithCheques,
  AverageBasketCardWithoutCheques,
} from "./AverageBasketCard"
import { ChequeCashingRateCard } from "./ChequeCashingRateCard"
import { VisitorStatCard } from "./VisitorStatCard"

export const LoyaltyProgramSection = (loyaltyProgramData: LoyaltyProgramData) => {
  if (!hasLoyaltyProgramData(loyaltyProgramData)) {
    return <EmptySection />
  }

  return (
    <Stack gap={2}>
      <KPIContainer>
        <NumberKPIDisplay
          label="NOMBRE DE PORTEURS"
          value={loyaltyProgramData.numCardHolders}
        />
        <Divider orientation="vertical" flexItem sx={{ marginY: 3 }} />
        <PriceKPIDisplay
          label="CHIFFRE AFFAIRES"
          value={loyaltyProgramData.saleStats?.mainStat}
        />
        <LoyaltyProgramEvolution
          title="EVOLUTION GLOBALE"
          subtitle="par rapport à l’année précédente"
          evolution={loyaltyProgramData.saleStats?.evolution}
        />
      </KPIContainer>
      <CardContainer>
        <ChequeCashingRateCard
          Icon={GiftCardIcon}
          title="Encaissement"
          subtitle="Chèques cadeaux"
          value={loyaltyProgramData.loyaltyChequesCashingRate}
        />
        <AverageBasketCardWithCheques
          Icon={ShoppingCart}
          title="Panier moyen"
          subtitle="avec chèque cadeaux"
          value={loyaltyProgramData.averageBasketWithCheques}
        />
        <AverageBasketCardWithoutCheques
          Icon={ShoppingCart}
          title="Panier moyen"
          subtitle="sans chèque cadeaux"
          value={loyaltyProgramData.averageBasketWithoutCheques}
        />
        <Divider orientation="vertical" flexItem sx={{ marginY: 3 }} />
        <VisitorStatCard
          Icon={Users}
          title="Fréquentation"
          subtitle="moyenne"
          keyFigure={loyaltyProgramData.visitorStats}
        />
      </CardContainer>
      {loyaltyProgramData.lastSyncDate && (
        <SyncDate date={loyaltyProgramData.lastSyncDate} />
      )}
      <LoyaltyProgramButton
        href={window.CONTEXT.myDataVizUrl}
        label="Plus de détails sur MyDataviz"
      />
    </Stack>
  )
}

const KPIContainer = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  gap: theme.spacing(10),
  padding: theme.spacing(0, 1),
  marginBottom: theme.spacing(8),
}))

const CardContainer = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  gap: theme.spacing(4),
}))
